import type { PricingRegion } from './computeOrderPricing';

const NORTHEAST = new Set(['ME', 'NH', 'VT', 'MA', 'RI', 'CT', 'NY', 'NJ', 'PA', 'DE', 'WV', 'VA']);
const SOUTHERN = new Set(['NC', 'SC', 'GA', 'FL']);

const NAME_TO_ABBR: Record<string, string> = {
  MAINE: 'ME',
  'NEW HAMPSHIRE': 'NH',
  VERMONT: 'VT',
  MASSACHUSETTS: 'MA',
  'RHODE ISLAND': 'RI',
  CONNECTICUT: 'CT',
  CONN: 'CT',
  'NEW YORK': 'NY',
  'NEW JERSEY': 'NJ',
  PENNSYLVANIA: 'PA',
  DELAWARE: 'DE',
  'WEST VIRGINIA': 'WV',
  VIRGINIA: 'VA',
  'NORTH CAROLINA': 'NC',
  'SOUTH CAROLINA': 'SC',
  GEORGIA: 'GA',
  FLORIDA: 'FL',
};

export function normalizeStateCode(state: string | null | undefined): string {
  if (!state) return '';
  const cleaned = state.trim().replace(/\./g, '').toUpperCase();
  if (cleaned.length === 2) return cleaned;
  return NAME_TO_ABBR[cleaned] ?? cleaned;
}

export function resolveRegion(state: string | null | undefined): PricingRegion {
  const code = normalizeStateCode(state);
  if (NORTHEAST.has(code)) return 'NORTHEAST';
  if (SOUTHERN.has(code)) return 'SOUTHERN';
  return 'OTHER';
}

export const REGION_LABELS: Record<PricingRegion, string> = {
  NORTHEAST: 'Northeast',
  SOUTHERN: 'Southern',
  OTHER: 'Other (one-off)',
};

export const REGION_OPTIONS: { value: PricingRegion; label: string }[] = [
  { value: 'NORTHEAST', label: REGION_LABELS.NORTHEAST },
  { value: 'SOUTHERN', label: REGION_LABELS.SOUTHERN },
  { value: 'OTHER', label: REGION_LABELS.OTHER },
];
